module.exports = __webpack_public_path__ + "img/ic_plus_square_grey.f130fbfb.svg";